import { Formik, FormikConfig, FormikProps } from "formik";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

import { Button } from "@/components/Button";
import { VALIDATION_TYPES } from "@/components/Formik";
import { Text } from "@/components/Text";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { Flex } from "@/eworkitComponents";
import { FormikCodelistManagersSelect } from "@/views/components/Formik";
import { Messenger } from "@/views/components/Messenger";

export const CONTACT_PERSON_MESSENGER_CONTEXT = "assignment-contact-person-form";

export const validationContactPersonSectionSchema = Yup.object().shape({
  consultantProfile: Yup.object().required(VALIDATION_TYPES.REQUIRED),
});

export interface IContactPersonFormValues {
  consultantProfile: IConsultantProfile;
  readonly companyId: number;
}

export interface IContactPersonFormik extends FormikConfig<IContactPersonFormValues> {
  onCancel?: () => void;
}

export const ContactPersonFormik: FC<IContactPersonFormik> = React.memo(
  ({ initialValues, onSubmit, onCancel, ...rest }) => {
    const { t } = useTranslation("session");

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationContactPersonSectionSchema}
        onSubmit={onSubmit}
        {...rest}>
        {(form: FormikProps<IContactPersonFormValues>) => (
          <Flex grow={1} direction="column" innerMargin="lg">
            <Messenger context={CONTACT_PERSON_MESSENGER_CONTEXT} />

            <Flex direction="column">
              <FormikCodelistManagersSelect
                name="consultantProfile"
                value={form.values.consultantProfile}
                searchParams={{
                  companyId: form.values.companyId,
                }}
                isClearable={false}
              />
            </Flex>

            <Flex justify="flex-end" innerMargin="md">
              <Button variant="secondary" onClick={onCancel} size="lg" testName="cancel" disabled={form.isSubmitting}>
                <Text uppercase>{t("ASSIGNMENTS.DETAILS.CONTACT_PERSON.CANCEL_BUTTON")}</Text>
              </Button>
              <Button onClick={form.submitForm} size="lg" testName="delete" disabled={form.isSubmitting}>
                <Text uppercase>{t("ASSIGNMENTS.DETAILS.CONTACT_PERSON.SAVE_BUTTON")}</Text>
              </Button>
            </Flex>
          </Flex>
        )}
      </Formik>
    );
  },
);
